import _extends from "@babel/runtime/helpers/esm/extends";
import { getCookie, cookiesConstants, parsePath } from '@magalu/mixer-utils';
export var getCustomerId = function getCustomerId(staticCustomerId) {
  var CUSTOMER_ID = cookiesConstants.CUSTOMER_ID;
  return staticCustomerId || getCookie(CUSTOMER_ID);
};
export var getUrlProduct = function getUrlProduct(path, structure, adsSellerId) {
  var url = new URL(path, structure.config.domain);
  url.searchParams.set('ads', 'patrocinado');
  if (adsSellerId) {
    url.searchParams.set('seller_id', adsSellerId);
  }
  return parsePath(url.pathname.concat(url.search));
};
export var mountBrandUrl = function mountBrandUrl(brand) {
  var defaultUrl = '#';
  if (!brand || !brand.type || !brand.id) {
    return defaultUrl;
  }
  switch (brand.type) {
    case 'vendor':
      return "/lojista/".concat(brand.id);
    case 'url':
      return brand.id;
    case 'product':
      if (Array.isArray(brand == null ? void 0 : brand.products)) {
        var product = brand.products.find(function (p) {
          return p.id === brand.id;
        });
        return product && (product == null ? void 0 : product.path) ? product.path : defaultUrl;
      }
      return defaultUrl;
    default:
      return defaultUrl;
  }
};
export var parseBrand = function parseBrand(brand, structure) {
  var _brand$products, _brand$content, _brand$content$creati;
  if (!brand) return null;
  var brandProducts = brand == null ? void 0 : (_brand$products = brand.products) == null ? void 0 : _brand$products.filter(function (product) {
    return product.price;
  }).map(function (product) {
    return _extends({}, product, {
      path: getUrlProduct(product.path, structure, product.adsSellerId)
    });
  });
  return _extends({}, brand, {
    content: _extends({}, brand.content, {
      imageUrl: (brand == null ? void 0 : (_brand$content = brand.content) == null ? void 0 : (_brand$content$creati = _brand$content.creatives) == null ? void 0 : _brand$content$creati.length) ? brand.content.creatives[0] : null,
      redirectUrl: mountBrandUrl(_extends({}, brand, {
        products: brandProducts
      }))
    }),
    products: brandProducts
  });
};